"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); //===============
// meta action types
//===============

var INITIALISE_GAME = exports.INITIALISE_GAME = "INITIALISE_GAME";
var FEEDBACK_SUBMITTED = exports.FEEDBACK_SUBMITTED = "FEEDBACK_SUBMITTED";
var LOADING_REQUEST = exports.LOADING_REQUEST = "LOADING_REQUEST";
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = "LOGIN_SUCCESS";
var LOGIN_FAILURE = exports.LOGIN_FAILURE = "LOGIN_FAILURE";
var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = "LOGOUT_FAILURE";
var REGISTER_SUCCESS = exports.REGISTER_SUCCESS = "REGISTER_SUCCESS";
var REGISTER_FAILURE = exports.REGISTER_FAILURE = "REGISTER_FAILURE";
var PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
var PASSWORD_RESET_FAILURE = exports.PASSWORD_RESET_FAILURE = "PASSWORD_RESET_FAILURE";
var FORGOTTEN_PASSWORD_SUCCESS = exports.FORGOTTEN_PASSWORD_SUCCESS = "FORGOTTEN_PASSWORD_SUCCESS";
var FORGOTTEN_PASSWORD_FAILURE = exports.FORGOTTEN_PASSWORD_FAILURE = "FORGOTTEN_PASSWORD_FAILURE";
var GET_FRIENDS_SUCCESS = exports.GET_FRIENDS_SUCCESS = "GET_FRIENDS_SUCCESS";
var GET_FRIEND_REQUESTS_SUCCESS = exports.GET_FRIEND_REQUESTS_SUCCESS = "GET_FRIEND_REQUESTS_SUCCESS";
var SENT_FRIEND_REQUEST_SUCCESS = exports.SENT_FRIEND_REQUEST_SUCCESS = "SENT_FRIEND_REQUEST_SUCCESS";
var GET_SENT_REQUEST_SUCCESS = exports.GET_SENT_REQUEST_SUCCESS = "GET_SENT_REQUEST_SUCCESS";
var DECLINE_FRIEND_REQUEST_SUCCESS = exports.DECLINE_FRIEND_REQUEST_SUCCESS = "DECLINE_FRIEND_REQUEST_SUCCESS";
var ACCEPT_FRIEND_REQUEST_SUCCESS = exports.ACCEPT_FRIEND_REQUEST_SUCCESS = "ACCEPT_FRIEND_REQUEST_SUCCESS";
var FRIEND_ERROR = exports.FRIEND_ERROR = "FRIEND_ERROR";
var RESET_FRIEND_ERROR = exports.RESET_FRIEND_ERROR = "RESET_FRIEND_ERROR";
var REGISTER_USER_ERROR = exports.REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
var CLEAR_META_ERROR = exports.CLEAR_META_ERROR = "CLEAR_META_ERROR";
var STORE_AVATAR_URL_SUCCESS = exports.STORE_AVATAR_URL_SUCCESS = "STORE_AVATAR_URL_SUCCESS";
var UPDATE_FRIENDS_INFO = exports.UPDATE_FRIENDS_INFO = "UPDATE_FRIENDS_INFO";
var UPDATE_ARRAYS = exports.UPDATE_ARRAYS = "UPDATE_ARRAYS";